export default "__VITE_ASSET__2f1897eb__"